import React from "react";
import { Link } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { Card, CardContent } from "../misc/Card";

interface AnalyticsEmptyStateProps {
    window: number;
    // true hides "Add a listing": Auto Pilot imports the customer's listings
    // itself, so the nudge would send them to a page that has nothing to do.
    // null/undefined (state unknown) keeps both buttons.
    autopilotEnabled?: boolean | null;
    // false holds both buttons back while the Auto Pilot state is still
    // loading, so "Add a listing" never shows and then vanishes.
    ctaReady?: boolean;
}

const AnalyticsEmptyState: React.FC<AnalyticsEmptyStateProps> = ({ window, autopilotEnabled, ctaReady = true }) => (
    <Card className="mt-0">
        <CardContent className="flex flex-col items-center py-10 text-center">
            <BarChart3 className="h-10 w-10 text-secondary" />
            <h2 className="mt-3 text-lg font-semibold text-primary">
                No posts published in the last {window} days
            </h2>
            <p className="mt-1 max-w-md text-sm text-gray-500">
                Once Marabot publishes for you, your activity will show up here.
            </p>
            {ctaReady && (
                <div className="mt-4 flex gap-3">
                    {autopilotEnabled !== true && (
                        <Link
                            to="/listings"
                            className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
                        >
                            Add a listing
                        </Link>
                    )}
                    <Link
                        to="/my-content"
                        className="rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-primary hover:bg-gray-100"
                    >
                        Create content
                    </Link>
                </div>
            )}
        </CardContent>
    </Card>
);

export default AnalyticsEmptyState;
